import React from 'react';

const LogOut = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.1925 9.99992H16.6425M16.6425 9.99992L13.3092 13.3333M16.6425 9.99992L13.3092 6.66659M9.02917 16.6508L5.55583 16.6666C4.56 16.6716 3.75 15.8733 3.75 14.8874V5.11242C3.75 4.12992 4.55417 3.33325 5.5475 3.33325H9.1425"
        stroke="#4A9CA6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LogOut;
